<template lang='pug'>
  blue-layout( :user='user' :account='account' :biz='biz' )
    bf-wrapper#notifications.view.content.with-header.smaller.container
      bf-overlay#rsv-overlay.solid(
        v-if='rsv'
        :user='user',
        :account='account',
        :biz='biz',
        :data='rsv',
        @close='rsv = false'
      )
        template( v-slot:heading )
          h5 {{ $t('Reservation/Appointment Details') }}
        #rsv-dtls.container
          rsv-dtls.overlay(
            v-if='rsv'
            :rsv='rsv'
            :options='{ show: { biz: true, cus: true } }'
          )
        rsv-msgs#rsv-msgs(
          v-if='rsv && account'
          :rsv='rsv'
          :account='account'
          :key='rsv.id'
        )

      notifications-tabs( :account='account' :notifications='notifications' :biz='biz' )

      h4( v-if='!notes.length' ) {{$t("No Messages")}}!
      span(v-else) {{notes.length}} {{ $t("messages")}}
      .container.actionable( 
        v-for='n in notes' 
        :key='n.id'
        :class='{ read: n.read }'
        @click='view( n )' 
      )
        .remove.actionable(@click.stop='remove(n)')
          remove-icon

        bf-flex.rsv.note.container(
          v-if='n.type == "ref"'
          :class='{ customer: true, merchant: false }'
        )
          .avatar.actionable( @click='$router.push({ name: "merchant", params: { id: n.ref.for.biz.id} })' )
            img( :src='n.ref.for.biz.logo || "/no-image.png"' )
          .contents.actionable( @click='$router.push({ name: "merchant", params: { id: n.ref.for.biz.id} })' )
            .name-date
              span.name {{ n.title }}
              span.date {{ n.created.toDate().toLocaleString() }}
            .body {{ n.body }}
</template>
<script>
  import { db } from '@/main'
  import { View } from '@/mixins/view'
  import NotificationsTabs from '@/components/tabs/notifications'

  export default {
    name: 'ref-notifications.view',

    mixins: [View],

    components: {
      NotificationsTabs
    },

    props: [ 'notifications' ],

    data() {
      return {
        rsv: false
      }
    },

    computed: {
      notes() {
        // return this.notifications
        if ( this.biz && this.account ) return this.notifications.filter( n => {
          if( n.type == 'ref') return n.for == this.account.id
          else return false
          }
        )
        else return []
      }
    },

    methods: {
      remove(n) {
        db.collection('notifications').doc(n.id).delete()
      },

      view( n ) {
        db.collection( 'notifications' ).doc( n.id ).update({ read: true }).then( () => console.log('updated', n) )
        this.rsv = n.rsv
      }
    }
  }
</script>

<style scoped lang='stylus'>
  #rsv-overlay
    margin-top 16px
  
  .container
    margin 12px 0
    .remove
      position absolute
      right 2px
      top 2px
      font-size 1.2em
      z-index 1
      opacity .75
    &.read .note
      background rgb( 240 240 240 )
      
  .note
    padding 8px
    border 1.5px solid rgb( 240 240 240 )
    border-radius 5px
    line-height 1.5
    font-size .92em
    &.customer
      background rgb( 240 255 240 )
    &.merchant
      background rgb( 255 250 240 )

  .container
    align-items center

  .avatar
    margin-right 16px
    img
      width 48px
      height 48px
      object-fit cover
      border-radius 50%

  label
    margin-right 4px

  .name, .datetime
    font-weight bold
    color var(--clr-blue-light)
    margin-right 8px

  .date
    font-size .8em
    color rgb( 144 144 144 )

  .type
    font-weight bold
</style>
